import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { LessonCardShell } from "./LessonCardShell";
import { LessonMetaRow } from "./LessonMetaRow";
import type { SuggestedLesson } from "./types";

type Props = {
	lesson: SuggestedLesson;
	onPress: (lesson: SuggestedLesson) => void;
	cardWidth?: number;
};

export const SuggestedLessonCard = ({
	lesson,
	onPress,
	cardWidth = 264,
}: Props) => {
	const theme = useAppTheme();

	return (
		<LessonCardShell
			cardWidth={cardWidth}
			thumbnailUrl={lesson.thumbnailUrl}
			onPress={() => onPress(lesson)}
		>
			<Box gap={8}>
				<Text variant="bodyLarge" numberOfLines={2}>
					{lesson.title}
				</Text>
				<Text
					variant="bodyMedium"
					numberOfLines={3}
					style={{
						color: theme.colors.onSurfaceVariant,
						minHeight: 60,
					}}
				>
					{lesson.description}
				</Text>
				<LessonMetaRow meta={lesson.meta} />
			</Box>
		</LessonCardShell>
	);
};
